import { useEffect } from "react";
import { useMutation } from "@tanstack/react-query";
import { loginWithTelegramInitData } from "../api/authApi";
import { useAuthStore } from "../store/authStore";
import WebApp from "@twa-dev/sdk";
import { logger } from "@/shared/utils/logger";

export const useTelegramInitDataAuth = () => {
  const { setAccessToken, accessToken } = useAuthStore();
  const isMiniApp = !!WebApp.initData;

  const authMutation = useMutation({
    mutationFn: loginWithTelegramInitData,
    retry: 3,
    onSuccess: (response) => {
      setAccessToken(response.accessToken);
      logger.info("User authenticated successfully.");
    },
  });

  useEffect(() => {
    if (isMiniApp && !accessToken && !authMutation.isPending && !authMutation.isError) {
      authMutation.mutate(WebApp.initData);
    }
  }, [authMutation, isMiniApp, accessToken]);

  return { isAuthenticated: !!accessToken, isMiniApp, authMutation };
};